import styled, { css } from 'styled-components';

const COMMON_PILL_STYLES = css`
    display: flex;
    padding: 6px 11px;
    align-items: flex-start;
    gap: 6px;
`;

const COMMON_SVG_STYLES = css`
    stroke: #fff;
    width: 18px;
    height: 18px;
`;

export const CardPillLabelsWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    position: absolute;
    top: 8px;
    left: 8px;
    width: calc(100%);
`;

export const CardPills = styled.div`
    display: flex;
    padding-right: 16px;
    flex: 1 0 0;
`;

export const CardPillLabel = styled.div`
    display: flex;
    height: 27px;
    padding: 6px 11px;
    min-width: 120px;
    align-items: flex-start;
    gap: 6px;
    border-radius: var(--border-radius-round, 48px);
    border: 1px solid var(--colors-surface-page, #e7f4ff);
    background: var(--colors-surface-page, #e7f4ff);
`;

export const CardPillIcon = styled.div`
    display: flex;
    width: 16px;
    height: 16px;
    justify-content: center;
    align-items: center;
`;
export const Spacer = styled.div`
    flex: 1;
`;

export const PillsStatus = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    div {
        color: var(--colors-text-on-action, #fff);
    }
`;

export const PillOverdue = styled.div`
    ${COMMON_PILL_STYLES};
    width: 102px;
    height: 27px;
    border-radius: var(--border-radius-round, 48px);
    background: var(--colors-icons-error, #da1e28);

    svg {
        stroke: #fff;
    }
`;

export const PillDueSoon = styled.div`
    ${COMMON_PILL_STYLES};
    border-radius: var(--border-radius-round, 48px);
    background: var(--colors-yellow-400, #eb9d06);

    svg {
        ${COMMON_SVG_STYLES};
    }
`;

export const PillCompleted = styled.div`
    ${COMMON_PILL_STYLES};
    border-radius: var(--border-radius-round, 48px);
    background: var(--colors-icons-success, #22a06b);

    svg {
        ${COMMON_SVG_STYLES};
    }
`;

export const PillRefresher = styled.div`
    display: flex;
    padding: 6px 11px;
    align-items: flex-start;
    gap: 6px;
    border-radius: var(--border-radius-round, 48px);
    border: 1px solid var(--colors-icons-warning, #eb9d06);
    background: var(--colors-icons-warning, #eb9d06);
`;
export const PillUpdated = styled.div`
    display: flex;
    width: 102px;
    padding: 6px 11px;
    align-items: flex-start;
    gap: 6px;
    border-radius: var(--border-radius-round, 48px);
    border: 1px solid #661887;
    background: #661887;
`;

export const PillYouTube = styled.div`
    display: flex;
    width: fit-content;
    padding: 6px 11px;
    align-items: flex-start;
    gap: 6px;
    border-radius: var(--border-radius-round, 48px);
    border: var(--border-width-sm_1, 1px) solid var(--colors-border-default, #b4b8bf);
    background: var(--neutral-150, #f1f4f8);
`;
